import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Text,
  Group,
  Switch,
  createStyles,
} from "@mantine/core";

import StripeModel from "../../../../models/Stripe";

import { colors } from "../../../../collections/colors";
import Swal from "sweetalert2";

const useStyles = createStyles((theme) => ({
  itemTitle: {
    fontSize: 18,
  },
  itemDescription: {
    fontSize: 14,
    color: theme.colors.gray[6]
  },
  switch: {
    "& *": {
      cursor: "pointer",
    },
  },
}));

export default function TaxCollection() {
  const { classes } = useStyles();

  const [taxEnabled, setTaxEnabled] = useState(false);

  const space = useSelector((state) => state.space);

  useEffect(() => {
    if (space?.payment_settings?.tax_collection) {
      setTaxEnabled(true);
    }
  }, []);

  const onTaxCollection = (event) => {
    const enabled = event.currentTarget.checked;
    setTaxEnabled(enabled);
    StripeModel.onTaxCollection(
      space.slug,
      enabled,
      (data) => {
        if (data.is_enabled === false) {
          setTaxEnabled(false);
          showSwalMessage("Your Stripe account has not been configured to collect taxes. Please activate Stripe Tax and try again.")
        }
      },
      (error) => {
        setTaxEnabled(false);
        showSwalMessage("Something went wrong with your Stripe account connection. If the problem persists, please contact us at support@sutra.co.");
      }
    );
  };

  const showSwalMessage = (message) => {
    Swal.fire({
      title: "Tax collection",
      html: message,
      confirmButtonText: "Ok",
      confirmButtonColor: colors.blue,
    }).then((result) => {
      if (result.isConfirmed) {
        
      }
    });
  };

  return (
    <Group position="apart" noWrap spacing="xl" mt={10}>
      <div>
        <Text className={classes.itemTitle}>
          {"Collect taxes on every transaction"}
        </Text>
        <Text className={classes.itemDescription}>
          {"People will be required to enter their address to complete payment for this space."}
        </Text>
      </div>
      <Switch
        onLabel="ON"
        offLabel="OFF"
        className={classes.switch}
        size="lg"
        checked={taxEnabled}
        onChange={onTaxCollection}
      />
    </Group>
  );
}
